import { render, staticRenderFns } from "./ChatHeaderExpanded.vue?vue&type=template&id=406f3cb8&scoped=true&"
import script from "./ChatHeaderExpanded.vue?vue&type=script&lang=js&"
export * from "./ChatHeaderExpanded.vue?vue&type=script&lang=js&"
import style0 from "./ChatHeaderExpanded.vue?vue&type=style&index=0&id=406f3cb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406f3cb8",
  null
  
)

export default component.exports